window.nffleet_variables = {

    //misc
    emptyString: "",

    //tags
    bodyTag: "body",
    divTag: "div",
    formTag: "form",
    buttonTag: "button",
    h2Tag: "h2",
    pTag: "p",
    fieldsetTag: "fieldset",
    labelTag: "label",
    textareaTag: "textarea",
    inputTag: "input",

    //attributes
    requiredAttribute: "required",

    //classes
    selectableClass: "selectable",
    activeClass: "active",
    showClass: "show",
    openedClass: "opened",
    invalidClass: "invalid",

    //custom event listeners
    destroyListener: "destroy",
    formSubmittedListener: "formSubmitted",

    //native event listeners
    clickListener: "click",
    scrollListener: "scroll",
    changeListener: "change",
    focusListener: "focus"
};